export const APP_NOTIFICATIONS_ID = 'notification-portal';
